import React from "react";
import styles from "./tracking-icon.module.css"

const TrackingTickIcon = () =>
<svg className={styles.trackingIcon} width="24px" height="24px" viewBox="0 0 24 24">
  <g id="Tick-circle-s(accept,-yes)" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
    <g id="Group">
      <rect id="Rectangle" fill="#D8D8D8" opacity="0" x="0" y="0" width="24" height="24"></rect>
      <g id="Group-Copy" transform="translate(2.000000, 2.000000)" fill="#fff">
        <path d="M10,0 C15.5228475,0 20,4.4771525 20,10 C20,15.5228475 15.5228475,20 10,20 C4.4771525,20 0,15.5228475 0,10 C0,4.4771525 4.4771525,0 10,0 Z M14.4949747,6.77632536 C14.2216077,6.50295835 13.7783923,6.50295835 13.5050253,6.77632536 L13.5050253,6.77632536 L8.5,11.782 L6.49497475,9.77632536 C6.22160774,9.50295835 5.77839226,9.50295835 5.50502525,9.77632536 C5.23165825,10.0496924 5.23165825,10.4929078 5.50502525,10.7662749 L8.00502525,13.2662749 C8.14170876,13.4029584 8.32085438,13.4713001 8.5,13.4713001 L8.60714768,13.4630991 C8.74910539,13.4412297 8.88562795,13.3756217 8.99497475,13.2662749 L8.99497475,13.2662749 L14.4949747,7.76627485 C14.7683418,7.49290785 14.7683418,7.04969236 14.4949747,6.77632536 Z" id="Combined-Shape"></path>
      </g>
    </g>
  </g>
</svg>
;

export default TrackingTickIcon